import PropTypes from 'prop-types';
import React, {Component} from 'react';
import get from 'lodash/get';
import {icons, iconStyles} from './icons';
import {Icon} from "~/native-ui";

export default class WebsailIcon extends Component {
    static propTypes = {
        value: PropTypes.string
    };

    render() {
        let { value, className, ...other } = this.props;

        let SvgIcon = get(icons, value),
            iconStyle = get(iconStyles, value, {});

        if(other.style) {
            iconStyle = {...iconStyle, ...other.style};
        }

        if(SvgIcon) {
            return <SvgIcon className={className} {...other} style={iconStyle} />
        }

        return <Icon value={value} {...other} />
    }
}